import React from 'react';
import { useWizard } from 'react-use-wizard';

const WizardProgress = ({ labels = [] }) => {
    const { activeStep, stepCount } = useWizard();

    if (typeof activeStep !== 'number') {
        console.warn("WizardProgress: Wizard context not available");
        return (
            <div className="wizard-progress text-center mb-3">
                <strong>Loading wizard...</strong>
            </div>
        );
    }

    const currentLabel = labels[activeStep] ?? `Step ${activeStep + 1}`;

    return (
        <div className="wizard-progress text-center mb-3">
            <strong className="fs-5 fw-semibold">
                Step {activeStep + 1} of {stepCount}: {currentLabel}
            </strong>
        </div>
    );
};

export default WizardProgress;